import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import axios from 'axios';

import Header from "../../../../components/layout/Header";
import Wrapper from "../../../../components/layout/Wrapper";
import Footer from "../../../../components/layout/Footer";
import Breadcrumb from "../../../../components/layout/Breadcrumb";
import AccountSidebar from "../../AccountSidebar";
import {useAuth} from "../../../../context/AuthProvider";
import PageTitle from "../../../../components/layout/PageTitle";
import CheatsheetRenderer from "./CheatsheetRenderer";
import {COURSE_API_BASE} from "../../../../utils/apiConfig";

const CheatSheetPage = () => {

    const {course_id, cheatsheet_id} = useParams();

    const {user} = useAuth();

    const [cheatsheet, setCheatsheet] = useState(null);
    const [loading, setLoading] = useState(true);

    const breadC = [
        {
            title: 'حساب‌کاربری',
            link: '#'
        },
        {
            title: 'دوره‌های من',
            link: '/fa/account/course'
        },
        {
            title: `${course_id}`,
            link: `/fa/account/course/${course_id}`
        },
        {
            title: 'تقلب‌نامه',
            link: `/fa/account/course/${course_id}/cheatsheet`
},
{
    title: cheatsheet?.title || 'تقلب‌نامه',
        link: `/fa/account/course/${course_id}/cheatsheet/${cheatsheet_id}`
}
];

useEffect(() => {
    fetchCheatsheet();
}, [course_id, cheatsheet_id]);

const fetchCheatsheet = async () => {
    try {
        setLoading(true);

        const response = await axios.get(
            `${COURSE_API_BASE}/${user.id}/courses/${course_id}/cheatsheets/${cheatsheet_id}`,
            {
                withCredentials: true
            }
        );

        if (response.data.success) {
            setCheatsheet(response.data.cheatsheet);
        } else {
            setCheatsheet(null);
        }

    } catch (error) {
        console.error('Failed to fetch cheatsheet:', error);
        setCheatsheet(null);
    } finally {
        setLoading(false);
    }
};

return (
    <div className="min-h-screen flex flex-col">

        <Header/>

        <main className="flex-1 my-8">

            <Wrapper>

                <div className="w-full flex flex-1 gap-x-10">

                    {user && (
                        <AccountSidebar
                            name={user.name}
                            phone_number={user.phone_number}
                            credit={user.credit}
                            streak={user.streak}
                            xp={user.xp}
                            character={user.character}
                        />
                    )}

                    <div className="w-4/5">

                        <Breadcrumb
                            items={breadC}
                            wrapper={false}
                        />

                        {loading ? (

                            <div className="py-10 text-center text-gray-500">
                                در حال بارگذاری...
                            </div>

                        ) : !cheatsheet ? (

                            <div className="bg-gray-100 rounded-xl p-8 text-center text-gray-500">
                                تقلب‌نامه پیدا نشد.
                            </div>

                        ) : (

                            <>

                                <PageTitle
                                    title={cheatsheet.title}
                                />

                                {cheatsheet.subtitle && (
                                    <p className="mt-2 mb-8 text-gray-500">
                                        {cheatsheet.subtitle}
                                    </p>
                                )}

                                <div
                                    className="
                                            bg-white
                                            border
                                            border-gray-200
                                            rounded-xl
                                            p-6
                                            mt-6
                                        "
                                >
                                    <CheatsheetRenderer
                                        content={cheatsheet.content}
                                    />
                                </div>

                            </>

                        )}

                    </div>

                </div>

            </Wrapper>

        </main>

        <Footer/>

    </div>
);
};

export default CheatSheetPage;
